var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { Table } from 'reactstrap';
var EmptyRow = function (props) {
    return (React.createElement("tr", null,
        React.createElement("td", { key: 'empty-row', colSpan: props.colSpan }, props.children)));
};
export function ODListablePaginatedTable2(props) {
    var _a, _b;
    var numColumns = props.numColumns, renderHeader = props.renderHeader, renderRow = props.renderRow, listableContext = props.listableContext, renderEmpty = props.renderEmpty, _c = props.onEvent, onEvent = _c === void 0 ? function () { return null; } : _c, eventParentContext = props.eventParentContext, tableStyle = props.tableStyle, _d = props.borderLess, borderLess = _d === void 0 ? false : _d;
    var rendererContext = React.useState(function () { return ({
        onEvent: onEvent,
        parentContext: eventParentContext,
    }); })[0];
    var _e = React.useContext(listableContext), state = _e.state, keyExtractor = _e.keyExtractor;
    var loading = state.loading, list = state.list;
    if (loading) {
        return React.createElement(React.Fragment, null, "Loading...");
    }
    var styles = {
        marginTop: 0,
        borderBottom: "1px solid #c8ced2",
    };
    var theadStyle = {
        background: '#F6F8FA'
    };
    return (React.createElement(Table, { responsive: true, hover: true, borderless: borderLess, style: __assign({ marginTop: 0 }, tableStyle) },
        React.createElement("thead", { style: theadStyle }, renderHeader()),
        React.createElement("tbody", null,
            list.length > 0 && list.map(function (v) { return renderRow(v, rendererContext); }),
            list.length === 0 && React.createElement(EmptyRow, { colSpan: numColumns }, (_b = (_a = renderEmpty) === null || _a === void 0 ? void 0 : _a(state), (_b !== null && _b !== void 0 ? _b : 'No data.'))))));
}
//# sourceMappingURL=ODListablePaginationTable2.js.map